// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBdHHfABnyMYaz8PsigwJQ1_BWh5g1kRuE",
  authDomain: "logisticsshippweb.firebaseapp.com",
  projectId: "logisticsshippweb",
  storageBucket: "logisticsshippweb.firebasestorage.app",
  messagingSenderId: "646754703033",
  appId: "1:646754703033:web:d315674067ff77d4b8ed68",
  measurementId: "G-57RJ67NR2N"
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

// Function to get permission and token
export const requestForToken = async () => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey: "BIFobzGHawF-JUX-NdXAJ9qlEem-4eGS2K-XVNGgKRpSqJnzul-aOSgCy9wo8I8I8hnyyLLtMLxZAxmyw_EvITI",
    });
    if (currentToken) {
      console.log("FCM Token:", currentToken);
      // yahan aap token apne backend ko bhej sakte ho
    } else {
      console.log("No registration token available");
    }
  } catch (err) {
    console.error("An error occurred while retrieving token. ", err);
  }
};

// Foreground message listener
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
